'use client';

import { Badge } from '../../components/badge';
import { BadgeHttp } from '../../components/styled/badge-http';

type EndpointMethodBadgeProps = {
  method: string;
  size?: 'sm' | 'md';
};

export function EndpointMethodBadge({
  method,
  size = 'sm',
}: EndpointMethodBadgeProps) {
  if (method === 'WS' || method === 'WSS') {
    return (
      <Badge size={size} variant="fill">
        {method}
      </Badge>
    );
  }

  return (
    <BadgeHttp method={method} size={size}>
      {method}
    </BadgeHttp>
  );
}
